import { render, staticRenderFns } from "./courseAsk.vue?vue&type=template&id=743e7174"
import script from "./courseAsk.vue?vue&type=script&lang=js"
export * from "./courseAsk.vue?vue&type=script&lang=js"
import style0 from "./courseAsk.vue?vue&type=style&index=0&id=743e7174&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports